import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';

const initialState = {
	loading: false,
	loadingW: false,
	results: null,
	weekResults: null,
	dailyWinners: null,
	weeklyWinners: null
}

const getResultsByDay = (state, action) => {
	return updateObject ( state, { 
		loading: true
	});
}

const getResultsByWeek = (state, action) => {
	return updateObject ( state, { 
		loadingW: true
	});
}

const setResultsByDay = (state, action) => {
	return updateObject ( state, { 
		results: action.results,
		loading: false
	});
}

const setResultsByWeek = (state, action) => {
	return updateObject ( state, { 
		weekResults: action.weekResults,
		loadingW: false
	});
}

const setDailyWinners = (state, action) => {
	return updateObject ( state, {
		dailyWinners: action.winners
	})
}

const setWeeklyWinners = (state, action) => {
	return updateObject ( state, {
		weeklyWinners: action.winners
	})
}

const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
		case actionTypes.GET_RESULTS_BY_DAY: return getResultsByDay(state, action);
		case actionTypes.GET_RESULTS_BY_WEEK: return getResultsByWeek(state, action);
		case actionTypes.SET_RESULTS_BY_WEEK: return setResultsByWeek(state, action);
		case actionTypes.SET_RESULTS_BY_DAY: return setResultsByDay(state, action);
		case actionTypes.GET_WINNERS_BY_DAY: return setDailyWinners(state, action);
		case actionTypes.GET_WINNERS_BY_WEEK: return setWeeklyWinners(state, action);
        default:
            return state;
    }
};

export default reducer;


// WEBPACK FOOTER //
// ./src/store/reducers/result.js